import { createFileRoute } from "@tanstack/react-router";
import GhidCumparatori from "@/pages/GhidCumparatori";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/kauferleitfaden/")({
  head: () => routeHead("/de/kauferleitfaden/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GhidCumparatori />
  );
}
